import { Routes } from '@angular/router';

import { BookListComponent } from '../book/book-list/book-list.component';
import { EditBookComponent } from '../book/edit-book/edit-book.component';

export const routes :Routes = [
	{path: 'books', component: BookListComponent},
	{path: 'books/add', component: EditBookComponent},
	{path: 'books/:id', component: EditBookComponent},
	{path: '', redirectTo: '/books', pathMatch: 'full'}
];


